import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [meta, setMeta] = useState(null);
  const [loading, setLoading] = useState(true);

  const refreshMeta = useCallback(async () => {
    const { data } = await api.get("/meta");
    setMeta(data);
  }, []);

  const bootstrap = useCallback(async () => {
    if (!localStorage.getItem("ep_token")) return setLoading(false);
    try {
      const [{ data: u }, { data: m }] = await Promise.all([api.get("/auth/me"), api.get("/meta")]);
      setUser(u);
      setMeta(m);
    } catch {
      localStorage.removeItem("ep_token");
    }
    setLoading(false);
  }, []);

  useEffect(() => { bootstrap(); }, [bootstrap]);

  const login = async (userId) => {
    const { data } = await api.post("/auth/demo-login", { user_id: userId });
    localStorage.setItem("ep_token", data.token);
    const { data: m } = await api.get("/meta");
    setMeta(m);
    setUser(data.user);
  };

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("ep_token");
    setUser(null);
    setMeta(null);
  };

  return <AuthCtx.Provider value={{ user, meta, loading, login, logout, refreshMeta }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
